// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "honre-suas-escolhas.firebaseapp.com",
  "projectId": "honre-suas-escolhas",
  "storageBucket": "honre-suas-escolhas.appspot.com",
  "messagingSenderId": "574061926282",
  "appId": "1:574061926282:web:fa7fdfaa2077a6c0c81a73",
  "measurementId": "G-TSKRRCVEBD",
  "apiKey": "AIzaSyCwLZH25mGBmPO1bbUNaHyfjG_iYXZjdFg"
};
